// src/admin/customers/CustomerBulkActionBar.jsx
import React from "react";

export default function CustomerBulkActionBar({
  selectedCount,
  onActivate,
  onSuspend,
  onExport,
  onClear,
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        background: "#0F172A",
        borderRadius: 10,
        padding: "8px 14px",
        animation: "fadeIn 0.15s ease",
      }}
    >
      <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }`}</style>
      <span
        style={{
          fontSize: 13,
          fontWeight: 600,
          color: "#fff",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          whiteSpace: "nowrap",
        }}
      >
        {selectedCount} selected
      </span>
      <div style={{ width: 1, height: 16, background: "rgba(255,255,255,0.15)" }} />
      <button
        onClick={onActivate}
        style={{
          padding: "5px 12px",
          borderRadius: 6,
          border: "1px solid rgba(255,255,255,0.15)",
          background: "transparent",
          color: "#fff",
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          whiteSpace: "nowrap",
        }}
      >
        Activate
      </button>
      <button
        onClick={onSuspend}
        style={{
          padding: "5px 12px",
          borderRadius: 6,
          border: "1px solid rgba(255,255,255,0.15)",
          background: "transparent",
          color: "#FCA5A5",
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          whiteSpace: "nowrap",
        }}
      >
        Suspend
      </button>
      <button
        onClick={onExport}
        style={{
          padding: "5px 12px",
          borderRadius: 6,
          border: "1px solid rgba(255,255,255,0.15)",
          background: "transparent",
          color: "#A5B4FC",
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          whiteSpace: "nowrap",
        }}
      >
        Export CSV
      </button>
      <button
        onClick={onClear}
        style={{
          padding: "5px 8px",
          borderRadius: 6,
          border: "none",
          background: "transparent",
          color: "rgba(255,255,255,0.5)",
          fontSize: 12,
          cursor: "pointer",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
      >
        ✕
      </button>
    </div>
  );
}